import {
	Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ElementRef,
	ChangeDetectionStrategy, ChangeDetectorRef
} from '@angular/core';
import { ApiKeyDto } from 'UvExplorerServer.Dtos.TS/Auth';
import { ApiKeyComponent } from '../apikey/apikey.component';
import { MessageService } from 'base';
import { ApiKeysService } from '../../services/apikeys.service';
import { IdentityService } from 'identity';


@Component({
	selector: 'apikey-dialog',
	templateUrl: './apikey-dialog.component.html'
})
export class ApiKeyDialogComponent {

	@Input()
	public visible: boolean;

	@Input()
	public target: ApiKeyDto;

	@Input()
	public create: boolean;

	@Output()
	public visibleChange: EventEmitter<boolean>;

	@Output()
	public onOk: EventEmitter<ApiKeyDto>;

	@Output()
	public onCancel: EventEmitter<any>;

    @ViewChild(ApiKeyComponent, { static: true })
	public apiKey: ApiKeyComponent;

	constructor(private apiKeysService: ApiKeysService,
		private messageService: MessageService,
		private changeDetector: ChangeDetectorRef,
		private identityService: IdentityService) {

		this.visible = false;
		this.target = null;
		this.create = false;
		this.visibleChange = new EventEmitter<boolean>();
		this.onOk = new EventEmitter<ApiKeyDto>();
		this.onCancel = new EventEmitter<any>();
	}

	public get enableOk(): boolean {
		return this.apiKey.enableApply;
	}

	public get dialogTitle(): string {
		return (this.create ? "Create API Key" : "Edit API Key");
	}

	public show(): void {
		this.visible = true;
		this.visibleChange.emit(true);

		this.changeDetector.markForCheck();
	}

	public hide(): void {
		this.visible = false;
		this.visibleChange.emit(false);

		this.changeDetector.markForCheck();
	}

	public onDialogHide(): void {
		this.hide();
		this.onCancel.emit();
	}

	public onCancelClicked(): void {
		this.hide();
		this.onCancel.emit();
	}

	public onOkClicked(): void {
		if (this.target) {
			this.apiKey.applyTempChanges();

			if (this.create) {
				this.apiKeysService.createApiKey(this.target).subscribe(
					(result: ApiKeyDto) => {
						result.Owner = this.identityService.user.Username;
						this.hide();
						this.onOk.emit(result);
						this.messageService.displayInfoMessage("API key successfully created");
					},
					(error) => {
						this.messageService.displayErrorMessage("Creating API key failed");
					});
			}
			else {
				this.apiKeysService.updateApiKey(this.target).subscribe(
					(result: ApiKeyDto) => {
						this.hide();
						this.onOk.emit(result);
						this.messageService.displayInfoMessage("API key successfully updated");
					},
					(error) => {
						this.messageService.displayErrorMessage("Updating API key failed");
					});
			}
		}
	}

	public ngOnChanges(changes: SimpleChanges): void {

		if (changes["target"]) {
		}

	}

}
